import React, { useRef } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Partner_Portal } from "../Configuration/API_URL";
import { toast } from "react-toastify";
import axios from "axios";
import { decryptData, encryptData, handleFileUpload, onlyNumber, validatePan } from "../CommonMethods/CommonMethods";
import previosPageArrow from "../asset/images/revamp-images/previousPageBtn.svg";
import PreviewModal from "./PreviewModal";
import DocumentUploader from "./DocumentUploader";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, useWatch } from "react-hook-form";
import { cityStateList } from "../CommonMethods/CityStateMaster";
import { Modal } from "react-bootstrap";
import thumbIcon from "../asset/images/partner-portal/thumbs.svg";
import DigiDocumentUploader from "./DigiDocumentUploader";
import SmallLoader from "../Components/Common/smallLoader";


const DigiDocumentList = (props) => {
    const manualselect = localStorage.getItem("manualUpload");
    const incompleteAddress = localStorage?.getItem("incompleteAddress")
    const incompletePan = localStorage.getItem("incompletePan")
    // const activeTab = localStorage.getItem("activeSection");
    const impsSuccess = props?.impsSuccess;
    const manualDoc = props?.manualDoc;
    const uploadSelfie = props?.uploadSelfie;
    const setUploadedSelfie = props?.setUploadedSelfie;
    const setShowBankDetails = props?.setShowBankDetails;
    const showBankDetails = props?.showBankDetails;
    const setManualDoc = props?.setManualDoc;
    const setImpsSuccess = props?.setImpsSuccess;
    const partnerToken = localStorage.getItem("partner_signup_token");
    const [fileStates, setFileStates] = useState({});
    const [fileErrors, setFileErrors] = useState({});
    const [previewUrl, setPreviewUrl] = useState("");
    const [viewUrl, setViewUrl] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [previewFileName, setPreviewFileName] = useState("");
    const [isOptionDisable, setIsOptionDisable] = useState(false);
    const [panLoader, setPanLoader] = useState(false);
    const [addressLoader, setAddressLoader] = useState(false);
    const navigate = useNavigate();
    const [cityListVal, setCityListVal] = useState([]);
    const [isApiPrefill, setIsApiPrefill] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const digiFlow = props?.digiFlow;
    const [panNum, setPanNum] = useState("");
    const addressSection = props?.addressSection;
    const setAddressSection = props?.setAddressSection
    const setDigiFlow = props?.setDigiFlow;
    const [values, setValues] = useState(false);
    const [pincodeType, setPincodeType] = useState(false);
    // const [pincodeDisable, setPincodeDisable] = useState(false);


    const schema = Yup.object().shape({
        panValid: Yup.string()
            .required("PAN is required")
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN format")
            .max(10, "PAN must be 10 characters"),
        nameValid: Yup.string()
            .required("Full name is required"),
        // .matches(/^[A-Z\s]+$/, "Only alphabets allowed")
        // .max(40, "Max 40 characters"),
        dobValid: Yup.date()
            .typeError("Please enter a valid calendar date")
            .required("DOB is required")
            .max(new Date(), "Date cannot be greater than today")
            .test("is-18", "You must be at least 18 years old", function (value) {
                if (!value) return false;
                const today = new Date();
                const eighteenYearsAgo = new Date();
                eighteenYearsAgo.setFullYear(today.getFullYear() - 18);
                return value <= eighteenYearsAgo;
            }),

        showAadharSec: Yup.boolean(),
        aadharNumber: Yup.string().when("showAadharSec", {
            is: true,
            then: (schema) =>
                schema
                    .required("Aadhaar Number is required")
                    .test(
                        "aadhar-valid",
                        "Aadhaar must be 12 digits",
                        (value) => {
                            if (!value) return false;
                            if (value.includes("X")) {
                                return value.length === 12;
                            }

                            return /^\d{12}$/.test(value);
                        }
                    ),
            otherwise: (schema) => schema.notRequired(),
        }),
        addressLine1: Yup.string().when("showAadharSec", {
            is: true,
            then: (schema) => schema.required("Address Line 1 is required"),
            otherwise: (schema) => schema.notRequired(),
        }),

        addressLine2: Yup.string().when("showAadharSec", {
            is: true,
            then: (schema) => schema.required("Address Line 2 is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        pincode: Yup.string().when("showAadharSec", {
            is: true,
            then: (schema) =>
                schema
                    .required("Pincode is required")
                    .matches(/^\d{6}$/, "Pincode must be 6 digits"),
            otherwise: (schema) => schema.notRequired(),
        }),

        state: Yup.string().when("showAadharSec", {
            is: true,
            then: (schema) => schema.required("State is required"),
            otherwise: (schema) => schema.notRequired(),
        }),

        city: Yup.string().when("showAadharSec", {
            is: true,
            then: (schema) => schema.required("City is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
    });

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        setError,
        clearErrors,
        trigger,
        control,
        watch,
        formState: { errors, isValid },
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
    });

    const pincode = watch("pincode");
    const selectedState = watch("state");
    const showAadharSec = watch("showAadharSec");
    const selectedCity = watch("city");

    const baseDocuments = [
        { label: "PAN Card", docKey: "1", isDefault: true },
        { label: "Aadhaar Card (Front side)", docKey: "2", isDefault: true },
        { label: "Aadhaar Card (Back side)", docKey: "3", isDefault: true },
        { label: "Bank Proof (Cancelled Cheque, Passbook or, Bank Statement)", docKey: "4", isDefault: true },
        { label: "Upload Selfie Photo", docKey: "5", isDefault: true },
        // ...((checkVerified || isImpsValid) ? [{ label: "Cancelled Cheque", docKey: "11", isDefault: true }] : []),
    ]

    const initializeDocumentData = () => {
        const initialState = {};
        baseDocuments.forEach(({ docKey }) => {
            initialState[docKey] = { name: "", isAvailable: false, url: "", type: "" };
        });
        return initialState;
    };
    const [documentData, setDocumentData] = useState(initializeDocumentData);

    if (partnerToken == null) {
        window.location.replace("/partner");
    }

    useEffect(() => {
        if ((incompleteAddress === "true" && uploadSelfie !== true && incompletePan !== "true") ||
            addressSection === true) {
            setValue("showAadharSec", true);
        }

    }, [addressSection, incompleteAddress]);

    const getUploadedDocsList = async () => {
        try {
            const getValueList = await axios.get(
                Partner_Portal.GetDocumentsList_Url + "/0",

                {
                    headers: {
                        "Content-Type": "text/plaint",
                        Authorization: `Bearer ${partnerToken}`,
                    },
                }
            );
            const getDocListRes = decryptData(getValueList?.data);
            const decryptedDocList = JSON.parse(getDocListRes);
            console.log(decryptedDocList, "decryptedDocList");

            if (decryptedDocList?.status === 0) {
                let docValue = decryptedDocList?.data?.info;
                localStorage.setItem("documentListManual", docValue?.length);

                if (docValue !== "") {
                    getSignupPartnerDetail();
                }
                const sampleData = {};
                const uploadedDocKeys = [];
                docValue.forEach((doc) => {
                    const key = String(doc?.type);
                    if (!key) return;

                    sampleData[key] = {
                        name: doc?.fileName || "",
                        isAvailable: true,
                        url: doc?.s3Url || "",
                        type: doc?.type || "",
                    };
                    uploadedDocKeys.push(key);
                });
                setDocumentData(sampleData);
            } else if (decryptedDocList?.status === 1) {
                localStorage.removeItem("documentListManual");
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 500) {
                toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if (error?.request?.status === 401) {
                localStorage.clear("");
                navigate("/partner");
            }
        }
    };

    useEffect(() => {
        getUploadedDocsList();
    }, []);

    const uploadeDocuments = async (e, type) => {
        try {
            const formData = new FormData();

            formData.append("file", e?.target?.files[0]);
            formData.append("type", type);

            const getValue = await axios.post(
                Partner_Portal.GetDocumentsList_Url,
                formData,
                {
                    headers: {
                        // "Content-Type": "text/plain",
                        Authorization: `Bearer ${partnerToken}`,
                    },
                }
            );
            const response = decryptData(getValue?.data);
            const decryptedResp = JSON.parse(response);
            console.log(decryptedResp, "uploadedResp");

            if (decryptedResp?.status === 0) {
                setPincodeType(false);

                let object = {
                    isAvailable: true,
                    type: type,
                    url: decryptedResp?.data?.info?.fileUrl,
                };
                setDocumentData({ ...documentData, [type]: object });
                
                if (decryptedResp?.data?.info?.type === "3") {
                    setIsApiPrefill(true)
                }
                getUploadedDocsList();
            } else if (decryptedResp?.status === 1) {
                toast.error(decryptedResp?.message);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 500) {
                toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if (error?.request?.status === 401) {
                localStorage.clear("");
                navigate("/partner");
            }
        }
    };

    const deleteDocuments = async (data) => {
        let encryptedPayload = {
            fileType: data,
        };
        let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));

        try {
            const getDeleteData = await axios.delete(
                Partner_Portal.GetDocumentsList_Url,

                {
                    data: encPayloadVal,
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${partnerToken}`,
                    },
                }
            );
            const deletedResp = decryptData(getDeleteData?.data);
            const decryptedDeleteResp = JSON.parse(deletedResp);
            if (decryptedDeleteResp?.status === 0) {
                // setDeleteData(decryptedDeleteResp?.message)
                toast.success(decryptedDeleteResp?.data?.message);
                getUploadedDocsList();

                let object = { [data]: { isAvailable: false, type: data, url: "" } };
                setDocumentData({ ...documentData, ...object });
            } else {
                toast.error(decryptedDeleteResp?.message);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 500) {
                toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if (error?.request?.status === 401) {
                localStorage.clear("");
                navigate("/partner");
            }
        }
    };

    const deleteDoc = (data) => {
        deleteDocuments(data);
    };

    const updatePanDetails = async (data) => {
        console.log(data, "updatePanDetails");
        // const dobVal = data?.dobValid.replace(/-/g, "");
        let dobVal = "";
        if (data?.dobValid) {
            const dob = new Date(data.dobValid);
            const day = String(dob.getDate()).padStart(2, "0");
            const month = String(dob.getMonth() + 1).padStart(2, "0");
            const year = dob.getFullYear();
            dobVal = `${day}${month}${year}`;
        }

        setPanLoader(true);
        let encryptedPayload = {
            pan: data?.panValid,
            nameOnPan: data?.nameValid,
            dob: dobVal

        };
        console.log(encryptedPayload, "encryptedPayload");

        let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
        try {
            const getValue = await axios.put(
                Partner_Portal.CreatePartner_Url,
                encPayloadVal,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${partnerToken}`,
                    },
                }
            );
            const getAddressData = decryptData(getValue?.data);
            const decrypAddData = JSON.parse(getAddressData);
            console.log(decrypAddData, "decrypAddData");

            if (decrypAddData?.status === 0) {

                setValue("showAadharSec", true);
                toast.success(decrypAddData?.data?.message)

            } else if (decrypAddData?.status === 1) {
                toast.error(decrypAddData?.message);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 500) {
                toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if (error?.request?.status === 401) {
                localStorage.clear("");
                navigate("/partner");
            }
        } finally {
            setPanLoader(false);
        }
    };

    const getSignupPartnerDetail = async () => {
        try {
            const getValues = await axios.get(
                Partner_Portal.CreatePartner_Url,
                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${partnerToken}`,
                    },
                }
            );
            const signupResp = decryptData(getValues?.data);
            const decryptedData = JSON.parse(signupResp);

            if (decryptedData?.status === 0) {
                let info = decryptedData?.data?.info || {};
                console.log(info, showAadharSec, "09888789");
                setPanNum(info?.pan)
                // if(info?.isDigilocker === true){
                // setDigiFlow(info?.isDigilocker);
                // }
                if (info?.pan !== null) {
                    setValue("panValid", info?.pan, { shouldValidate: true });
                }
                if (info?.dob !== null) {
                    // setValue("showAadharSec", false);
                    const dob = info.dob;

                    if (dob.length === 8) {
                        const day = dob.slice(0, 2);
                        const month = dob.slice(2, 4);
                        const year = dob.slice(4, 8);
                        const formattedDob = `${year}-${month}-${day}`;
                        setValue("dobValid", formattedDob, { shouldDirty: true, shouldValidate: true });
                    }
                }
                if (info?.nameOnPan !== null) {
                    // setValue("showAadharSec", false);
                    setValue("nameValid", info?.nameOnPan.toUpperCase(), { shouldValidate: true })
                }

                if (info?.aadharNumber !== null) {
                    if ((!manualDoc && !uploadSelfie && incompletePan !== "true") && addressSection === true) {
                        setValue("showAadharSec", true);
                    }
                    setValue("aadharNumber", info?.aadharNumber, { shouldValidate: true })
                    setValues(true)
                }
                if (info?.address !== null) {
                    if ((!manualDoc && !uploadSelfie && incompletePan !== "true") && addressSection === true) {
                        setValue("showAadharSec", true);
                    }
                    setValue("addressLine1", info?.address, { shouldValidate: true })
                }
                if (info?.address2 !== null) {
                    if ((!manualDoc && !uploadSelfie && incompletePan !== "true") && addressSection === true) {
                        setValue("showAadharSec", true);
                    }

                    setValue("addressLine2", info?.address2, { shouldValidate: true })
                }
                if (info?.pincode !== null) {
                    if ((!manualDoc && !uploadSelfie && incompletePan !== "true") && addressSection === true) {
                        setValue("showAadharSec", true);
                    }
                    setValue("pincode", info?.pincode, { shouldValidate: true })
                    // setIsApiPrefill(true);
                }
                if (info?.state !== null) {
                    if ((!manualDoc && !uploadSelfie && incompletePan !== "true") && addressSection === true) {
                        setValue("showAadharSec", true);
                    }
                    setValue("state", info?.state, { shouldValidate: true })
                    setIsOptionDisable(true)
                }
                if (info?.city !== null) {
                    if ((!manualDoc && !uploadSelfie && incompletePan !== "true") && addressSection === true) {
                        setValue("showAadharSec", true);
                    }
                    setValue("city", info?.city, { shouldValidate: true });
                    setIsOptionDisable(true);
                    setCityListVal([]);
                }

            } else if (decryptedData?.status === 1) {
                toast.error(decryptedData?.message);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 500) {
                toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if (error?.request?.status === 401) {
                localStorage.clear("");
                navigate("/partner");
            }
        }
    };

    useEffect(() => {
        getSignupPartnerDetail();
    }, []);

    const updateAddressDetails = async (values) => {
        console.log(values, "valuesaddress");
        setAddressLoader(true);

        // setAddressLoader(true);
        let encryptedPayload = {
            aadharNumber: values?.aadharNumber,
            address: values?.addressLine1,
            address2: values?.addressLine2,
            pincode: values?.pincode,
            state: values?.storeState ? values?.storeState : values?.state,
            city: values?.storeCity ? values?.storeCity : values?.city,
        };
        let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));

        console.log(encryptedPayload, "encPayloadVal");

        try {
            const getValue = await axios.put(
                Partner_Portal.CreatePartner_Url,
                encPayloadVal,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${partnerToken}`,
                    },
                }
            );
            const getAddressData = decryptData(getValue?.data);
            const decrypAddData = JSON.parse(getAddressData);

            if (decrypAddData?.status === 0) {

                // setAddressData(decrypAddData?.data);
                localStorage.setItem("showBankData", true)
                navigate("/partner/bank-details");
                toast.success(decrypAddData?.data?.message);
            } else if (decrypAddData?.status === 1) {
                toast.error(decrypAddData?.message);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 500) {
                toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if (error?.request?.status === 401) {
                localStorage.clear("");
                navigate("/partner");
            }
        } finally {
            setAddressLoader(false);

        }
    };

    console.log(pincodeType, "pincodeType");
    
    const getAddressZipcode = async (pinData) => {
        let encryptedPayload = {};
        let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
        try {
            const getValue = await axios.get(
                Partner_Portal.GetZipCode_Url + pinData,
                encPayloadVal,
                {
                    headers: {
                        "Content-Type": "text/plain",
                        // Authorization: `Bearer ${partnerToken}`
                    },
                }
            );
            const getZipcodeData = decryptData(getValue?.data);
            let decryptedZip = JSON.parse(getZipcodeData);
            console.log(decryptedZip, "cityStateVal");

            if (decryptedZip?.status === 0) {
                // setPincodeDisable(true);
                const info = decryptedZip.data.info;

                const stateVal = info[0].STATEDESC;
                const cityList = info.map((obj) => obj.CITYNAME);
                console.log(cityList, stateVal, "cityList");
                setValue("state", stateVal);

                if (cityList?.length === 1) {
                    const cityVal = info[0].CITYNAME
                    setValue("city", cityVal)
                    setCityListVal([])
                } else if (cityList?.length > 1 && pincodeType === true) {
                    setValue("city", "")
                    setCityListVal(cityList)
                }
                setIsOptionDisable(true)

            } else if (decryptedZip?.status === 1) {
                setIsOptionDisable(false)
                setCityListVal([]);
                toast.error(decryptedZip?.message);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 500) {
                toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if (error?.request?.status === 401) {
                localStorage.clear("");
                navigate("/partner");
            }
        }
    };

    useEffect(() => {
        if (!pincode) {
            setValue("state", "");
            setValue("city", "");
            setIsOptionDisable(false);
            setCityListVal([]);
            return;
        }

        if (pincode?.length === 6) {
            if (isApiPrefill) {
                getAddressZipcode(pincode);
                setIsOptionDisable(true);
            }
        } else {
            setValue("state", "");
            setValue("city", "");
            setIsOptionDisable(false);
            setCityListVal([]);
        }
    }, [pincode, isApiPrefill]);

    const previousBtn = () => {
        if (!digiFlow) {
            if (showAadharSec) {
                setValue("showAadharSec", false);
                setAddressSection(false)
                localStorage.removeItem("incompleteAddress");
                localStorage.removeItem("addressSection");
                localStorage.setItem("manualUpload", true)
                setManualDoc(true)
            } else if (manualDoc && !showAadharSec) {
                localStorage.removeItem("manualUpload");
                localStorage.removeItem("incompletePan");
                // localStorage.removeItem("incompleteAddress");
                setManualDoc(false)
            } else {
                navigate("/partner/basic-details")
            }
        }
        else {
            setDigiFlow(false);
            // setAddressSection(false);
        }
    };

    const onPreview = (url, name) => {
        setPreviewUrl(url);
        setPreviewFileName(name);
        setShowModal(true);
    };

    const updateApiSubmit = async () => {
        let encryptedPayload = {
            statusId: 1,
        };
        let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
        try {
            const getValues = await axios.put(
                Partner_Portal.CreatePartner_Url,
                encPayloadVal,

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${partnerToken}`,
                    },
                }
            );
            const signupResp = decryptData(getValues?.data);
            const decryptedUpdate = JSON.parse(signupResp);
            if (decryptedUpdate?.status === 0) {
                console.log(decryptedUpdate, "decryptedUpdate");
                setModalShow(false);
                setTimeout(navigate("/partner"), 10000);

            } else {
                toast.error(decryptedUpdate?.message);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 500) {
                toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
            }
            if (error?.request?.status === 401) {
                localStorage.clear("");
                navigate("/partner");
            }
        }
    };

    const onSubmit = (data) => {
        if (digiFlow) {
            localStorage.setItem("showBankData", true)
            navigate("/partner/bank-details")
        }
        else if (impsSuccess && !showBankDetails) {
            if (documentData["4"]) {
                setValue("showAadharSec", false);
                navigate("/partner/selfie-upload");
            }
        }
        else if (manualDoc && !showAadharSec) {
            updatePanDetails(data);
            localStorage.removeItem("manualUpload");
            localStorage.setItem("addressSection", true);
        } else if (showAadharSec) {

            updateAddressDetails(data)

        } else if (uploadSelfie) {
            setModalShow(true)
        }
    };

    const commonUploaderProps = ({ label, docKey, optional = false }) => {
        const type = docKey;

        return {
            key: docKey,
            label,
            docKey,
            optional,
            fileState: fileStates[docKey],
            setFile: (file) =>
                setFileStates((prev) => ({ ...prev, [docKey]: file })),
            error: fileErrors[docKey],
            setError: (err) =>
                setFileErrors((prev) => ({ ...prev, [docKey]: err })),
            onDelete: () => deleteDoc(docKey),
            onPreview: () => onPreview(documentData[docKey]?.url, documentData[docKey]?.name),

            documentData,
            handleUpload: ({ e, setFile, setError }) =>
                handleFileUpload({
                    e,
                    type,
                    setFile,
                    setError,
                    callback: () => {
                        uploadeDocuments(e, type);
                        if (docKey === "5") {
                            const file = e.target.files[0];
                            setViewUrl(URL.createObjectURL(file));
                        }
                    }
                }),
        };
    };

    useEffect(() => {
        if (documentData["5"]?.url) {
            setViewUrl(documentData["5"]?.url);
        }
    }, [documentData]);


    const NameInput = (event) => {
        const currentValue = event.target.value;
        const uppercasedValue = currentValue.toUpperCase();
        event.target.value = uppercasedValue;
    };

    const handlePanPaste = (e) => {
        e.preventDefault();

        const pastedText = e.clipboardData.getData("text").toUpperCase().trim();
        const cleanText = pastedText.replace(/[^A-Za-z0-9]/g, "").slice(0, 10);
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

        if (panRegex.test(cleanText)) {
            setValue("panValid", cleanText, { shouldValidate: true });
        } else {
            console.warn("Invalid PAN format pasted");
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();

        const pastedText = e.clipboardData.getData("text");
        const clean = pastedText
            .toUpperCase()
            .replace(/[^A-Z\s]/g, "")
            .replace(/\s+/g, " ")
            .trim();

        const currentVal = getValues("nameValid") || "";
        let newValue = `${currentVal} ${clean}`.replace(/\s+/g, " ").trim();

        newValue = newValue.slice(0, 50);

        setValue("nameValid", newValue, { shouldValidate: true });
        e.target.value = newValue;
    };

    const getCitiesForState = (stateName) => {
        if (!stateName) return [];
        const found = cityStateList.find((obj) => Object.keys(obj)[0] === stateName);
        if (!found) return [];
        const key = Object.keys(found)[0];
        return found[key].city.map((c) => c.name);
    };

    const cities = cityListVal?.length > 0 ? [] : getCitiesForState(selectedState);

    useEffect(() => {
        if (!isOptionDisable && selectedState) {
            setValue("city", "");
        }
    }, [selectedState, setValue, isOptionDisable]);

    useEffect(() => {
        if (cityListVal?.length && !cityListVal.includes(selectedCity)) {
            setValue("city", "");
        }
    }, [cityListVal, selectedCity, setValue]);

    const handleBankDetail = () => {
        localStorage.setItem("showBankData", true)
        setShowBankDetails(true)
        setImpsSuccess(false)
    }

    const handlePastePincode = (fieldName) => (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData("text");
        let clean = pastedText.replace(/\D/g, "").trim().slice(0, 6);
        if (clean === "") return;
        setValue(fieldName, clean, { shouldValidate: true });
        e.target.value = clean;
    };

    const handleOk = () => {
        updateApiSubmit();
    };

    const isManualDocInvalid =
        (manualDoc && !showAadharSec) &&
        (!documentData["1"]?.isAvailable ||
            !getValues("panValid") || errors.panValid ||
            !getValues("nameValid") || errors.nameValid ||
            !getValues("dobValid") || errors.dobValid)

    const checkAddressValid =
        (showAadharSec && !impsSuccess) &&
        (
            !documentData["2"]?.isAvailable ||
            !documentData["3"]?.isAvailable ||
            !getValues("aadharNumber") || errors.aadharNumber ||
            !getValues("addressLine1") || errors.addressLine1 ||
            !getValues("addressLine2") || errors.addressLine2 ||
            !getValues("pincode") || errors.pincode ||
            !getValues("state") || errors.state ||
            !getValues("city") || errors.city)
        // &&
        // !isValid;

    const isDisabled =
        (impsSuccess && !showBankDetails && !documentData["4"]) ||
        (uploadSelfie && !documentData["5"]) ||
        checkAddressValid ||
        isManualDocInvalid;

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");


    const handleBackBtn = () => {
        if (impsSuccess) {
            handleBankDetail()
        } else if (uploadSelfie) {
            navigate("/partner/bank-details")
        }
        else {
            previousBtn()
        }
    }

    const handlePasteAddress = (fieldName) => (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData("text");
        let clean = pastedText
            // .toUpperCase()
            .replace(/[^A-Za-z0-9\s\-.,'#\+\/()&@]/g, "")
            // .replace(/[^A-Z0-9#\/\-&.,\s]/g, "")
            .replace(/\s{2,}/g, " ")
            .replace(/^\s+/, "")
            .slice(0, 50);
        if (clean === "") return;
        const input = e.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const currentValue = input.value;
        const newValue = (
            currentValue.slice(0, start) +
            clean +
            currentValue.slice(end)
        ).slice(0, 50);
        setValue(fieldName, newValue, { shouldValidate: true });
        input.value = newValue;
        const cursorPos = Math.min(start + clean.length, 50);
        setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
    };

    console.log(manualDoc, digiFlow, showAadharSec, impsSuccess, uploadSelfie, manualselect, "showDocList");

    return (
        <>
            <div className="page-header partner-doc-page right-box select-doc-scroll">
                <div className="wrap-all">
                    <div className="page-left landing-page viewheight">
                        <img
                            alt="back-btn"
                            className="previous-btn"
                            src={previosPageArrow}
                            href="previous page btn"
                            onClick={() => handleBackBtn()}

                        />
                        {digiFlow ?
                            <div>
                                <h2 className="page-title">
                                    Documents fetched from Digilocker
                                </h2>
                                <h3 className="page-subtitle partner-subtitle">
                                    Your documents are safe and is required for partner KYC
                                </h3>
                            </div>
                            :
                            <div>
                                <h2 className="page-title">
                                    {
                                        (impsSuccess && !showBankDetails) ?
                                            <>Upload cancelled cheque for bank verification</> :
                                            manualselect !== "true" && uploadSelfie ?
                                                <> Confirm Selfie</>
                                                :
                                                <>Upload documents hassle free</>
                                    }

                                </h2>
                                <h3 className="page-subtitle partner-subtitle">
                                    {manualselect !== "true" && uploadSelfie ?
                                        <>Make sure your face is clearly visible</>
                                        : <>Your documents are safe and is required for partner KYC</>
                                    }

                                </h3>
                            </div>
                        }
                    </div>

                    <form
                        className="page-form landing-form"
                        autoComplete="off"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        {digiFlow ?
                            <div className="bank-detail-content">
                                {baseDocuments
                                    .filter(
                                        ({ docKey }) =>
                                            ["1", "2", "5"].includes(docKey)
                                    ).map((doc) => (
                                        <DigiDocumentUploader {...commonUploaderProps(doc)} />
                                    ))
                                }

                                <div className="pan-submit">
                                    <button
                                        type="submit"
                                        className={"partner-loginBtn"}
                                    // disabled={isDisabled}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                            :
                            <div className="bank-detail-content">
                                {
                                    (impsSuccess && !showBankDetails) ? (
                                        baseDocuments
                                            .filter(({ docKey }) => docKey === "4")
                                            .map((doc) => (
                                                <DocumentUploader key={doc.docKey} {...commonUploaderProps(doc)} />
                                            ))
                                    ) : ((manualDoc && !showAadharSec)) ? (
                                        baseDocuments
                                            .filter(({ docKey }) => docKey === "1")
                                            .map((doc) => (
                                                <DocumentUploader key={doc.docKey} {...commonUploaderProps(doc)} />
                                            ))
                                    ) : (showAadharSec && !impsSuccess) ? (
                                        baseDocuments.filter(
                                            ({ docKey }) =>
                                                ["2", "3"].includes(docKey)
                                        ).map((doc) => (
                                            <DocumentUploader {...commonUploaderProps(doc)} />
                                        ))
                                    ) : (uploadSelfie && manualselect === "true") ? (
                                        baseDocuments.filter(
                                            ({ docKey }) =>
                                                ["5"].includes(docKey)
                                        ).map((doc) => (
                                            <DocumentUploader {...commonUploaderProps(doc)} />
                                        ))) : ""
                                }

                                {(manualDoc || showAadharSec || impsSuccess || uploadSelfie)&&
                                    ((!digiFlow && !(impsSuccess && !showBankDetails) && !uploadSelfie) ?
                                        <div className="upload-instruction">
                                            <span className="format-info">
                                                Note: Please upload document in .Jpg, .Jpeg, .Png
                                                format with Max size of 200Kb or .Pdf format with Max
                                                size of 1Mb.
                                            </span>
                                        </div>
                                        :
                                        <div className="upload-instruction">
                                            <span className="format-info">
                                                Note: Please upload document in .Jpg, .Jpeg, .Png
                                                format with Min size of 5KB and Max size of 150KB.
                                            </span>
                                        </div>)
                                }


                                <div>
                                    {uploadSelfie && documentData["5"]?.url && (

                                        <div className="selfie-upload-sec">
                                            <div className="upload-docs__card uploadDG">
                                                <img
                                                    src={viewUrl}
                                                    alt="Uploaded selfie"
                                                    className="selfie-preview"
                                                    style={{ width: "360px", height: "215px" }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {(!digiFlow) &&
                                    <>
                                        {((manualDoc && !showAadharSec)) &&
                                            <div className="wrap-manual-input">
                                                <label className="text-label">
                                                    PAN Card Number
                                                    <span class="mandatory-label">*</span>
                                                </label>
                                                <div className="mobile-wrapper partner-pan-wrapper">
                                                    <input
                                                        type="text"
                                                        id="txtPANCard"
                                                        className="mt-2 form-control has-value is-invalid partner-mob"
                                                        maxLength={10}
                                                        onKeyPress={(e) => validatePan(e)}
                                                        // onInput={NameInput}
                                                        max={10}
                                                        onPaste={handlePanPaste}
                                                        autoComplete="off"
                                                        placeholder="Enter your PAN number"
                                                        {...register("panValid")}
                                                        disabled={panNum}
                                                        onChange={(e) => {
                                                            const start = e.target.selectionStart;
                                                            const end = e.target.selectionEnd;

                                                            let input = e.target.value
                                                            input = input
                                                                .toUpperCase()
                                                                .replace(/[^A-Z0-9]/gi, "")
                                                                .trimStart()
                                                                .slice(0, 10);

                                                            e.target.value = input;
                                                            setValue("panValid", input, { shouldValidate: true });

                                                            e.target.setSelectionRange(start, end);
                                                        }}
                                                    />
                                                    {errors.panValid && (
                                                        <p className="forget-link">
                                                            {errors.panValid.message}
                                                        </p>
                                                    )}
                                                </div>

                                                <label className="text-label">
                                                    Full Name
                                                    <span class="mandatory-label">*</span>
                                                </label>
                                                <div className="mobile-wrapper partner-pan-wrapper">
                                                    <input
                                                        type="text"
                                                        className="mt-2 form-control has-value is-invalid pan-background"
                                                        placeholder="Enter your full name"
                                                        maxLength={50}
                                                        onPaste={handlePaste}
                                                        {...register("nameValid")}
                                                        onInput={(e) => {
                                                            const start = e.target.selectionStart;
                                                            const end = e.target.selectionEnd;

                                                            let input = e.target.value;
                                                            input = input
                                                                .toUpperCase()
                                                                .replace(/[^A-Z\s]/g, "")
                                                                .replace(/\s+/g, " ")
                                                                .trimStart()
                                                                .slice(0, 50);

                                                            e.target.value = input;

                                                            e.target.setSelectionRange(start, end);
                                                        }}

                                                    />
                                                    {errors.nameValid && (
                                                        <p className="forget-link">
                                                            {errors.nameValid.message}
                                                        </p>
                                                    )}
                                                </div>

                                                <label className="text-label">
                                                    Date of Birth
                                                    <span class="mandatory-label">*</span>
                                                </label>

                                                <div className="mobile-wrapper partner-pan-wrapper">
                                                    <div className="mt-2 form-group calendar-icon">
                                                        <input
                                                            type="date"
                                                            className="datepicker form-control partner-dob-val"
                                                            id="dobValues"
                                                            placeholder="DD-MM-YYYY"
                                                            {...register("dobValid")}
                                                            max={DateReverse}
                                                        />
                                                    </div>
                                                    {errors.dobValid && (
                                                        <p className="forget-link">{errors.dobValid.message}</p>
                                                    )}
                                                </div>

                                            </div>
                                        }

                                        {(showAadharSec && !impsSuccess) &&
                                            <div className="row partner-pan-row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="text-label">
                                                        Aadhaar Number<span class="mandatory-label">*</span>
                                                    </label>
                                                    <div
                                                        className="form-group pan-input custom-suggest error-wrap address-input"
                                                    >
                                                        <input
                                                            maxLength={12}
                                                            type="text"
                                                            placeholder="Enter Aadhar Number"
                                                            nameattribute="pan1"
                                                            name="pan-input"
                                                            className="mt-2 form-control has-value is-invalid scroll address-field"
                                                            {...register("aadharNumber")}
                                                            onInput={onlyNumber}
                                                            // disabled={getValues("aadharNumber")}
                                                            disabled={values}
                                                        />

                                                        {errors.aadharNumber && (
                                                            <p className="forget-link">
                                                                {errors.aadharNumber.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-3">
                                                    <label className="text-label">
                                                        Address Line 1<span class="mandatory-label">*</span>
                                                    </label>
                                                    <div
                                                        className="form-group pan-input custom-suggest error-wrap address-input"
                                                    >
                                                        <input
                                                            maxLength={50}
                                                            type="text"
                                                            nameattribute="pan1"
                                                            name="pan-input"
                                                            className="mt-2 form-control has-value is-invalid scroll address-field"

                                                            {...register("addressLine1")}
                                                            onPaste={handlePasteAddress("addressLine1")}
                                                            onChange={(e) => {
                                                                const start = e.target.selectionStart;
                                                                const end = e.target.selectionEnd;

                                                                let input = e.target.value;
                                                                input = input.replace(/[^A-Za-z0-9\s\-.,'#\+\/()&@]/g, "");
                                                                // input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                                                                input = input.replace(/\s{2,}/g, " ");
                                                                input = input.replace(/^\s+/, "");

                                                                if (input.length > 50) input = input.slice(0, 50);
                                                                e.target.value = input;
                                                                setValue("addressLine1", input, { shouldValidate: true });
                                                                e.target.setSelectionRange(start, end);
                                                            }}

                                                            placeholder="Enter address line 1"
                                                        />

                                                        {errors.addressLine1 && (
                                                            <p className="forget-link">
                                                                {errors.addressLine1.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="text-label">
                                                        Address Line 2<span class="mandatory-label">*</span>
                                                    </label>
                                                    <div
                                                        className="form-group pan-input custom-suggest error-wrap address-input"
                                                    >
                                                        <input
                                                            maxLength={50}
                                                            type="text"
                                                            nameattribute="pan1"
                                                            placeholder="Enter address line 2"
                                                            name="pan-input"
                                                            autoComplete="new-password"
                                                            className="mt-2 form-control has-value is-invalid scroll address-field"
                                                            {...register("addressLine2")}
                                                            onPaste={handlePasteAddress("addressLine2")}
                                                            onChange={(e) => {
                                                                const start = e.target.selectionStart;
                                                                const end = e.target.selectionEnd;

                                                                let input = e.target.value
                                                                input = input.replace(/[^A-Za-z0-9\s\-.,'#\+\/()&@]/g, "");
                                                                // input = input.replace(/[^A-Z0-9#\/\-&.,\s]/g, "");
                                                                input = input.replace(/\s{2,}/g, " ");
                                                                input = input.replace(/^\s+/, "");

                                                                if (input.length > 50) input = input.slice(0, 50);
                                                                e.target.value = input;
                                                                setValue("addressLine2", input, { shouldValidate: true });
                                                                e.target.setSelectionRange(start, end);
                                                            }}
                                                        />
                                                        {errors.addressLine2 && (
                                                            <p className="forget-link">
                                                                {errors.addressLine2.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-3">
                                                    <label className="text-label">
                                                        Pincode
                                                        <span class="mandatory-label">*</span>
                                                    </label>
                                                    <div className="form-group partner-form-group error-wrap address-input">
                                                        <input
                                                            type="text"
                                                            maxLength={6}
                                                            placeholder="Enter your pincode"
                                                            className="mt-2 form-control has-value is-invalid datepicker address-field"
                                                            autoComplete="new-password"
                                                            onInput={(e) => {
                                                                onlyNumber(e);
                                                                setPincodeType(true);
                                                                setIsApiPrefill(true);
                                                            }}
                                                            // disabled={pincodeDisable}
                                                            onPaste={handlePastePincode("pincode")}
                                                            {...register("pincode")}
                                                        />

                                                        {errors.pincode && (
                                                            <p className="forget-link">
                                                                {errors.pincode.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-3">
                                                    <label className="text-label">
                                                        State
                                                        <span class="mandatory-label">*</span>
                                                    </label>
                                                    <div className="form-group partner-form-group error-wrap address-input">
                                                        <select
                                                            type="text"
                                                            className="mt-2 form-control has-value datepicker is-invalid"
                                                            autoComplete="new-password"
                                                            {...register("state")}
                                                            value={getValues("state")}
                                                            disabled={isOptionDisable}
                                                        >

                                                            {getValues("state") && isOptionDisable ?
                                                                <option value={getValues("state")}>{getValues("state")}</option>
                                                                : (
                                                                    <>
                                                                        <option value="">Select State</option>
                                                                        {cityStateList &&
                                                                            cityStateList.map((data, key) => {
                                                                                var allStates = Object.keys(data)[0];
                                                                                return (
                                                                                    <option
                                                                                        value={allStates}
                                                                                        className="opt"
                                                                                        key={key}
                                                                                    >
                                                                                        {allStates}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                    </>
                                                                )
                                                            }

                                                        </select>

                                                        {errors.state && (
                                                            <p className="forget-link">
                                                                {errors.state.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-3">
                                                    <div className="form-group partner-form-group error-wrap address-input">
                                                        <label className="text-label">
                                                            City
                                                            <span class="mandatory-label">*</span>
                                                        </label>
                                                        <select
                                                            type="text"
                                                            className="mt-2 form-control has-value is-invalid datepicker"
                                                            autoComplete="off"
                                                            {...register("city")}
                                                            value={selectedCity || ""}
                                                            onChange={(e) => setValue("city", e?.target?.value, { shouldDirty: true })}
                                                        // disabled={isOptionDisable}
                                                        >

                                                            {(getValues("city") && cityListVal?.length === 0 && isOptionDisable) ?
                                                                //  || pincodeDisable 
                                                                <option value={getValues("city")}>{getValues("city")}</option>
                                                                :
                                                                cityListVal?.length > 0 ? (
                                                                    <>
                                                                        <option value="">Select City</option>
                                                                        {cityListVal.map((cityListData) => (
                                                                            <option key={cityListData} value={cityListData}>
                                                                                {cityListData}
                                                                            </option>
                                                                        ))}
                                                                    </>
                                                                )
                                                                    :
                                                                    (
                                                                        <>
                                                                            <option value="">Select City</option>
                                                                            {cities.map((cityName) => (
                                                                                <option value={cityName}>
                                                                                    {cityName}
                                                                                </option>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                        </select>
                                                        {errors.city && (
                                                            <p className="forget-link">
                                                                {errors.city.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </>
                                }

                                <div className="pan-submit">
                                    <button
                                        type="submit"
                                        className={`${isDisabled ? "disable-esign-btn partner-loginBtn" : "partner-loginBtn"}`}
                                        disabled={isDisabled}
                                    >
                                        {panLoader || addressLoader ?
                                            <SmallLoader />
                                            : <>
                                                Submit
                                            </>}

                                    </button>
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </div>

            <PreviewModal
                show={showModal}
                onHide={() => setShowModal(false)}
                fileUrl={previewUrl}
                fileName={previewFileName}
            />

            <div className="congo-modal">
                <Modal
                    show={modalShow}
                    // onHide={onHide}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="ifscModal confirmation-modal"
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Body>
                        <img className="thumb-img" src={thumbIcon} alt="thumb icon" />
                        <form className="modal-form select-new">
                            <div className="form-group conf-modal">
                                <label htmlFor="bank-text" className="modal-heading">
                                    That’s Great! Your application is sent for review!
                                </label>
                                <span className="text-content">
                                    Once the verification is complete, we will notify you via
                                    email. Keep checking your inbox for the update!
                                </span>
                            </div>
                        </form>

                        <div className="text-center confirmation-button">
                            <button
                                className="common-btn conf-btn"
                                type="submit"
                                onClick={handleOk}
                            >
                                Okay
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};
export default DigiDocumentList;
